(() => {
  const rootSelector = '[data-cielo-product-tabs]';

  const categoryPatterns = {
    features: /(搭載キースイッチ|おすすめカスタム|主な特長|機能一覧)/,
    usage: /(使用感レビュー|プレイレビュー|総評|使用感・評価|機種評価)/,
    connection: /(取扱説明書|設定方法|接続方法|接続・設定|ファームウェア|マニュアル)/,
    specification: /(製品仕様|仕様一覧|詳細仕様|スペック)/
  };

  const v2HeadingCategories = {
    overview: 'description',
    features: 'description',
    configuration: 'features',
    'review-summary': 'usage',
    'manual-settings': 'connection',
    specification: 'specification'
  };

  const v2TabLabels = {
    description: '商品説明',
    features: '構成',
    usage: 'レビュー・総評',
    connection: '説明書・設定',
    specification: '詳細仕様'
  };

  const componentIcons = {
    lever: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 4v9m0-9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm-4 9h8l2 7H6l2-7Z"/></svg>',
    button: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="11" r="6"/><path d="M6 11v4c0 3 2.7 5 6 5s6-2 6-5v-4"/></svg>',
    'button-cap': '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 10c0-3.2 2.7-5 6-5s6 1.8 6 5v6H6v-6Zm-2 6h16v3H4v-3Z"/></svg>',
    microswitch: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="8" width="16" height="10" rx="2"/><path d="m7 8 2-4h8m-8 14v3m6-3v3"/></svg>',
    'control-part': '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v4m0 10v4M3 12h4m10 0h4m-3.6-5.4-2.8 2.8m-5.2 5.2-2.8 2.8m0-10.8 2.8 2.8m5.2 5.2 2.8 2.8"/><circle cx="12" cy="12" r="4"/></svg>'
  };

  const featureIcons = {
    response: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m13 2-9 12h7l-1 8 9-12h-7l1-8Z"/></svg>',
    wireless: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 9a10 10 0 0 1 14 0M8 12a6 6 0 0 1 8 0m-5 4a2 2 0 0 1 2 0"/><circle cx="12" cy="19" r="1"/></svg>',
    connection: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 7V3m6 4V3M7 7h10v3a5 5 0 0 1-5 5v6m-3 0h6"/></svg>',
    compatibility: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="4" width="13" height="10" rx="2"/><path d="M8 20h3m-1.5-6v6M18 8h3v10h-6v-2"/></svg>',
    switch: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="7" width="14" height="11" rx="2"/><path d="m8 7 2-4h4l2 4M9 18v3m6-3v3m-6-9h6"/></svg>',
    controls: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 8h8a6 6 0 0 1 5.5 8.4l-1 2.2a2 2 0 0 1-3.2.7L15 17H9l-2.3 2.3a2 2 0 0 1-3.2-.7l-1-2.2A6 6 0 0 1 8 8Z"/><path d="M7 12v4m-2-2h4m7-1h.01m3 2h.01"/></svg>',
    display: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="4" width="18" height="14" rx="2"/><path d="M8 22h8m-4-4v4M7 9h4m-4 4h7"/></svg>',
    lighting: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 1.4 4.1L18 8.5l-4.6 1.4L12 14l-1.4-4.1L6 8.5l4.6-1.4L12 3Z"/><path d="m18.5 14 .8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8.8-2.2ZM5 14l.6 1.7 1.7.6-1.7.6L5 18.6l-.6-1.7-1.7-.6 1.7-.6L5 14Z"/></svg>',
    lock: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10" width="14" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3m-4 4v3"/></svg>',
    construction: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 8 4v5c0 5-3.4 8-8 9-4.6-1-8-4-8-9V7l8-4Z"/><path d="m8.5 12 2.2 2.2 4.8-4.8"/></svg>',
    customize: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 9 5-9 5-9-5 9-5Z"/><path d="m3 12 9 5 9-5M3 16l9 5 9-5"/></svg>',
    settings: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h10m4 0h2M4 17h2m4 0h10M8 4v6m8 4v6"/><circle cx="8" cy="7" r="2"/><circle cx="16" cy="17" r="2"/></svg>',
    portable: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="7" width="18" height="13" rx="2"/><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 12h18M10 12v2h4v-2"/></svg>',
    audio: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 14v-2a8 8 0 0 1 16 0v2"/><path d="M4 14h3v6H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 1-2Zm16 0h-3v6h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-1-2Z"/></svg>',
    feature: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 2.6 5.3 5.9.9-4.3 4.2 1 5.9-5.2-2.8-5.2 2.8 1-5.9-4.3-4.2 5.9-.9L12 3Z"/></svg>'
  };

  const featureIconRules = [
    ['wireless', /(Bluetooth|2\.4\s*GHz|無線|ワイヤレス)/i],
    ['compatibility', /(対応機種|互換|PlayStation|PS[345]|Xbox|Nintendo|Switch|Windows|Android|iOS)/i],
    ['switch', /(キースイッチ|ホットスワップ|マイクロスイッチ|スイッチ交換)/i],
    ['display', /(OLED|ディスプレイ|画面)/i],
    ['lighting', /(RGB|LED|ライティング|発光)/i],
    ['lock', /(トーナメントロック|誤操作防止|ロック機能)/i],
    ['construction', /(アルミ|剛性|筐体|フレーム|耐久|安定|滑り止め)/i],
    ['customize', /(天板|アート|カスタム|マグネット|着脱|交換式)/i],
    ['settings', /(Web設定|設定ソフト|ソフトウェア|ファームウェア|マッピング)/i],
    ['portable', /(ハンドル|持ち運び|収納|軽量|コンパクト)/i],
    ['audio', /(ヘッドセット|イヤホン|音声|オーディオ|3\.5\s*mm)/i],
    ['connection', /(USB|Type-?C|接続|ケーブル|EXT|拡張端子|ポート)/i],
    ['response', /(8,?000\s*Hz|1,?000\s*Hz|ポーリング|低遅延|高速応答|応答速度|ラピッドトリガー|短ストローク)/i],
    ['controls', /(ボタン|レバー|入力|操作配置|レイアウト)/i]
  ];

  const resourceIcons = {
    manual: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 4.5A2.5 2.5 0 0 1 7.5 2H20v17H7.5A2.5 2.5 0 0 0 5 21.5v-17Z"/><path d="M5 19h15M9 6h7m-7 4h7"/></svg>',
    firmware: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="6" width="12" height="12" rx="2"/><path d="M9 1v5m6-5v5M9 18v5m6-5v5M1 9h5m-5 6h5m12-6h5m-5 6h5m-11-4h6v4H9v-4Z"/></svg>',
    'official-software': '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="4" width="18" height="14" rx="2"/><path d="M8 22h8m-4-4v4m-5-8 3-3-3-3m5 6h5"/></svg>',
    'gp2040-ce': '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="5" width="14" height="14" rx="2"/><path d="M9 1v4m6-4v4M9 19v4m6-4v4M1 9h4m-4 6h4m14-6h4m-4 6h4m-8-7-4 4 4 4"/></svg>',
    'connection-guide': '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 12h8m-6-4 4 8M5 5l4 4-4 4m14-2-4 4 4 4"/><circle cx="5" cy="5" r="2"/><circle cx="19" cy="19" r="2"/></svg>'
  };

  function hasMeaningfulContent(element) {
    if (!element) return false;
    return Boolean(
      element.textContent.trim() ||
      element.querySelector('img, video, iframe, table, ul, ol, a[href]')
    );
  }

  function headingText(heading) {
    return heading.textContent.replace(/\s+/g, ' ').trim();
  }

  function classifyHeading(heading) {
    const v2Heading = heading.dataset.cieloSectionHeading;
    if (v2Heading && v2HeadingCategories[v2Heading]) return v2HeadingCategories[v2Heading];
    const text = headingText(heading);
    if (/製品の特長/.test(text)) return 'description';
    if (categoryPatterns.features.test(text)) return 'features';
    if (categoryPatterns.usage.test(text)) return 'usage';
    if (categoryPatterns.connection.test(text)) return 'connection';
    if (categoryPatterns.specification.test(text)) return 'specification';
    return 'description';
  }

  function collectHeadingSection(heading) {
    const nodes = [];
    let node = heading;
    while (node) {
      const next = node.nextSibling;
      if (node !== heading && node.nodeType === Node.ELEMENT_NODE && /^H2$/i.test(node.tagName)) break;
      nodes.push(node);
      node = next;
    }
    return nodes;
  }

  function moveHeadingSection(heading, destination) {
    collectHeadingSection(heading).forEach((node) => destination.appendChild(node));
  }

  function removeHeadingSection(heading) {
    collectHeadingSection(heading).forEach((node) => node.remove());
  }

  function fillEvaluationSidebar(root, source) {
    const evaluation = root.querySelector('[data-cielo-product-evaluation]');
    if (!evaluation) return;

    const controllerHeadings = Array.from(source.querySelectorAll('h2')).filter((heading) =>
      /こんなコントローラー/.test(headingText(heading))
    );
    if (evaluation.dataset.cieloEvaluationPointsSource === 'app') {
      controllerHeadings.forEach(removeHeadingSection);
      return;
    }

    const goodList = evaluation.querySelector('[data-cielo-evaluation-good]');
    const noteList = evaluation.querySelector('[data-cielo-evaluation-note]');
    const goodWrap = evaluation.querySelector('[data-cielo-evaluation-good-wrap]');
    const noteWrap = evaluation.querySelector('[data-cielo-evaluation-note-wrap]');
    const points = evaluation.querySelector('[data-cielo-evaluation-points]');
    if (!goodList || !noteList || !goodWrap || !noteWrap || !points) return;

    const appendUnique = (list, text, type) => {
      const normalized = text.replace(/\s+/g, ' ').trim();
      if (!normalized) return;
      const existing = Array.from(list.children).some((item) => item.textContent === normalized);
      if (existing) return;
      const item = document.createElement('li');
      item.classList.add(`cielo-product-evaluation__point--${type}`);
      item.textContent = normalized;
      list.appendChild(item);
    };

    const fallback = source.querySelector('[data-cielo-evaluation-fallback]');
    const positiveFallback = fallback
      ? Array.from(fallback.querySelectorAll('[data-cielo-evaluation-fallback-point="positive"]'))
      : [];
    const concernFallback = fallback
      ? Array.from(fallback.querySelectorAll('[data-cielo-evaluation-fallback-point="concern"]'))
      : [];
    const hasCompleteV2Fallback = positiveFallback.length > 0 && concernFallback.length > 0;

    if (hasCompleteV2Fallback) {
      positiveFallback.forEach((item) => appendUnique(goodList, item.textContent, 'good'));
      concernFallback.forEach((item) => {
        const tone = item.dataset.cieloEvaluationFallbackTone === 'bad' ? 'bad' : 'note';
        appendUnique(noteList, item.textContent, tone);
      });
    } else {
      source.querySelectorAll('.good-point').forEach((item) => appendUnique(goodList, item.textContent, 'good'));
      source.querySelectorAll('.note-point').forEach((item) => appendUnique(noteList, item.textContent, 'note'));
      source.querySelectorAll('.bad-point').forEach((item) => appendUnique(noteList, item.textContent, 'bad'));
    }
    controllerHeadings.forEach(removeHeadingSection);

    const hasGood = goodList.children.length > 0;
    const hasNotes = noteList.children.length > 0;
    goodWrap.hidden = !hasGood;
    noteWrap.hidden = !hasNotes;
    points.hidden = !(hasGood || hasNotes);
  }

  function insertKnownIcon(target, iconMap, key) {
    if (!target || target.childElementCount > 0 || !iconMap[key]) return;
    target.innerHTML = iconMap[key];
  }

  function featureIconKey(title) {
    const normalized = title.replace(/\s+/g, ' ').trim();
    return featureIconRules.find(([, pattern]) => pattern.test(normalized))?.[0] || 'feature';
  }

  function insertFeatureIcons(source) {
    source.querySelectorAll('.cielo-prod-feature-item').forEach((item) => {
      const icon = item.querySelector(':scope > .cielo-prod-feature-icon');
      const title = item.querySelector('.cielo-prod-feature-title, h3');
      if (!icon || !title) return;
      const key = featureIconKey(title.textContent);
      const hadIcon = icon.childElementCount > 0;
      insertKnownIcon(icon, featureIcons, key);
      if (!hadIcon && icon.querySelector('svg')) icon.dataset.cieloFeatureIcon = key;
    });
  }

  function v2DescriptionRoot(source) {
    return source.querySelector(
      ':scope > .cielo-prod-container[data-cielo-description-version="2"]'
    );
  }

  function enhanceV2Description(root, source) {
    const v2Description = v2DescriptionRoot(source);
    if (!v2Description) return;

    Object.entries(v2TabLabels).forEach(([key, label]) => {
      const button = root.querySelector(`[data-cielo-tab="${key}"]`);
      if (button) button.textContent = label;
    });

    insertFeatureIcons(v2Description);

    v2Description.querySelectorAll('[data-cielo-component-icon]').forEach((icon) => {
      insertKnownIcon(icon, componentIcons, icon.dataset.cieloComponentIcon);
    });

    v2Description.querySelectorAll('.cielo-prod-switch-card').forEach((card) => {
      card.classList.toggle(
        'cielo-prod-switch-card--no-image',
        !card.querySelector(':scope > .cielo-prod-switch-image')
      );
    });

    v2Description.querySelectorAll('[data-cielo-resource-kind]').forEach((resource) => {
      const resourceKind = resource.dataset.cieloResourceKind;
      if (!resourceIcons[resourceKind]) return;
      let icon = resource.querySelector('.cielo-prod-resource-icon');
      if (!icon) {
        icon = document.createElement('span');
        icon.className = 'cielo-prod-resource-icon';
        icon.setAttribute('aria-hidden', 'true');
        resource.prepend(icon);
      }
      insertKnownIcon(icon, resourceIcons, resourceKind);
    });
  }

  function normalizeSpecValue(value) {
    return value
      .replace(/\s*mm\s*/gi, ' mm ')
      .replace(/\s*×\s*/g, ' × ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function fillQuickSpecs(root, source) {
    const quickCard = root.querySelector('[data-cielo-quick-specs-card]');
    const quickList = root.querySelector('[data-cielo-quick-specs]');
    if (!quickCard || !quickList) return;

    const values = {};
    source.querySelectorAll('table tr').forEach((row) => {
      const cells = row.querySelectorAll('th, td');
      if (cells.length < 2) return;
      const label = cells[0].textContent.replace(/\s+/g, '').trim();
      const value = normalizeSpecValue(cells[1].textContent);
      if (!value) return;

      if (/サイズ|寸法/.test(label) && !values.size) values.size = value;
      if (/重量|重さ/.test(label) && !values.weight) values.weight = value;
      if (/接続方式|接続方法|接続/.test(label) && !values.connection) values.connection = value;
      if (/対応機種|対応OS|互換性/.test(label) && !values.compatibility) values.compatibility = value;
    });

    if (!values.connection && root.dataset.quickConnection) {
      values.connection = root.dataset.quickConnection;
    }

    Object.entries(values).forEach(([key, value]) => {
      const row = quickList.querySelector(`[data-cielo-quick-spec="${key}"]`);
      if (!row) return;
      const description = row.querySelector('dd');
      if (description) description.textContent = value;
      row.hidden = false;
    });

    quickCard.hidden = Object.keys(values).length === 0;
  }

  function moveV2LeadToProductSummary(source) {
    const v2Description = v2DescriptionRoot(source);
    const lead = v2Description?.querySelector(':scope > p.cielo-prod-lead');
    const leadText = lead?.textContent.replace(/\s+/g, ' ').trim();
    if (!leadText) return;

    const ownerDocument = source.ownerDocument || document;
    const summary = ownerDocument.querySelector('[data-cielo-product-page] .cielo-product-summary');
    if (!summary) return;

    summary.textContent = leadText;
    lead.remove();
  }

  function splitDescription(root) {
    const source = root.querySelector('[data-cielo-description-source]');
    if (!source) return;

    enhanceV2Description(root, source);
    fillEvaluationSidebar(root, source);
    fillQuickSpecs(root, source);
    moveV2LeadToProductSummary(source);

    const destinations = {
      features: root.querySelector('[data-cielo-panel-content="features"]'),
      usage: root.querySelector('[data-cielo-panel-content="usage"]'),
      connection: root.querySelector('[data-cielo-panel-content="connection"]'),
      specification: root.querySelector('[data-cielo-panel-content="specification"]')
    };

    Array.from(source.querySelectorAll('h2')).forEach((heading) => {
      if (!heading.isConnected) return;
      const category = classifyHeading(heading);
      if (category !== 'description' && destinations[category]) {
        moveHeadingSection(heading, destinations[category]);
      }
    });

    Object.entries(destinations).forEach(([key, content]) => {
      const button = root.querySelector(`[data-cielo-tab="${key}"]`);
      const panel = root.querySelector(`[data-cielo-panel="${key}"]`);
      const available = hasMeaningfulContent(content);
      if (button) button.hidden = !available;
      if (panel && !available) panel.hidden = true;
    });

    const descriptionButton = root.querySelector('[data-cielo-tab="description"]');
    const descriptionPanel = root.querySelector('[data-cielo-panel="description"]');
    const descriptionAvailable = hasMeaningfulContent(source);
    if (descriptionButton) descriptionButton.hidden = !descriptionAvailable;
    if (descriptionPanel && !descriptionAvailable) descriptionPanel.hidden = true;

    const relatedButton = root.querySelector('[data-cielo-tab="related"]');
    const relatedPanel = root.querySelector('[data-cielo-panel="related"]');
    const relatedAvailable = Boolean(relatedPanel?.querySelector('[data-related-offers-kind="discount"]'));
    if (relatedButton) relatedButton.hidden = !relatedAvailable;
    if (relatedPanel && !relatedAvailable) relatedPanel.hidden = true;
  }

  function initFaq(root) {
    const faqItems = Array.from(root.querySelectorAll('.cielo-product-faq__item'));
    faqItems.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        faqItems.forEach((otherItem) => {
          if (otherItem !== item) otherItem.open = false;
        });
      });
    });
  }

  function removeEmptyFaq(root) {
    const faqPanel = root.querySelector('[data-cielo-panel="faq"]');
    const faqTab = root.querySelector('[data-cielo-tab="faq"]');
    if (!faqPanel || faqPanel.querySelector('.cielo-product-faq__item')) return;
    faqTab?.remove();
    faqPanel.remove();
  }

  function initEditorialSourcesModal(root) {
    const trigger = root.querySelector('[data-cielo-editorial-sources-trigger]');
    const dialog = root.querySelector('[data-cielo-editorial-sources-modal]');
    if (!trigger || !dialog || dialog.dataset.cieloEditorialSourcesReady === 'true') return;

    dialog.dataset.cieloEditorialSourcesReady = 'true';
    const closeButton = dialog.querySelector('[data-cielo-editorial-sources-close]');
    let lastTrigger = null;

    const focusableElements = () => Array.from(
      dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ).filter((element) => !element.hidden && element.getAttribute('aria-hidden') !== 'true');

    const restoreFocus = () => {
      if (lastTrigger?.isConnected) lastTrigger.focus({ preventScroll: true });
      lastTrigger = null;
    };

    const closeDialog = () => {
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
        restoreFocus();
      }
    };

    trigger.addEventListener('click', () => {
      lastTrigger = trigger;
      try {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      } catch (_error) {
        dialog.setAttribute('open', '');
      }
      requestAnimationFrame(() => (closeButton || focusableElements()[0])?.focus());
    });

    closeButton?.addEventListener('click', closeDialog);
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDialog();
    });
    dialog.addEventListener('close', restoreFocus);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const focusable = focusableElements();
      if (focusable.length === 0) {
        event.preventDefault();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function initTabs(root) {
    if (root.dataset.cieloTabsReady === 'true') return;
    root.dataset.cieloTabsReady = 'true';

    removeEmptyFaq(root);
    splitDescription(root);
    initFaq(root);
    initEditorialSourcesModal(root);

    const nav = root.querySelector('[data-cielo-tabs-nav]');
    const tabList = root.querySelector('[role="tablist"]');
    const nextButton = root.querySelector('[data-cielo-tabs-next]');
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
    const visibleTabs = () => tabs.filter((tab) => !tab.hidden);

    const syncOverflow = () => {
      if (!nav || !tabList || !nextButton) return;
      nav.classList.remove('has-overflow');
      nextButton.hidden = true;
      const hasOverflow = tabList.scrollWidth > tabList.clientWidth + 1;
      nav.classList.toggle('has-overflow', hasOverflow);
      nextButton.hidden = !hasOverflow;
      if (!hasOverflow) tabList.scrollTo({ left: 0, behavior: 'auto' });
    };

    const centerTab = (tab, behavior = 'smooth') => {
      if (!tabList || !tab) return;
      const targetLeft = tab.offsetLeft - ((tabList.clientWidth - tab.offsetWidth) / 2);
      tabList.scrollTo({ left: Math.max(0, targetLeft), behavior });
    };

    const activate = (tab, options = {}) => {
      if (!tab || tab.hidden) return;
      const panelId = tab.getAttribute('aria-controls');

      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.id !== panelId;
      });

      centerTab(tab, options.instant ? 'auto' : 'smooth');
      if (options.focus) tab.focus({ preventScroll: true });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        const available = visibleTabs();
        const index = available.indexOf(tab);
        let target = null;

        if (event.key === 'ArrowRight') target = available[(index + 1) % available.length];
        if (event.key === 'ArrowLeft') target = available[(index - 1 + available.length) % available.length];
        if (event.key === 'Home') target = available[0];
        if (event.key === 'End') target = available[available.length - 1];

        if (target) {
          event.preventDefault();
          activate(target, { focus: true });
        }
      });
    });

    if (nextButton && tabList) {
      nextButton.addEventListener('click', () => {
        tabList.scrollBy({ left: Math.max(180, tabList.clientWidth * 0.62), behavior: 'smooth' });
      });
    }

    const selected = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true' && !tab.hidden);
    activate(selected || visibleTabs()[0], { instant: true });
    syncOverflow();
    requestAnimationFrame(syncOverflow);
    window.addEventListener('resize', syncOverflow, { passive: true });
  }

  function initAll(scope = document) {
    scope.querySelectorAll(rootSelector).forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
